import { apiFetch } from './client';

export interface Member {
  member_id: string;
  name: string;
  role: string;
  voice_pack?: string;
}

export async function listMembers(): Promise<Member[]> {
  const r = await apiFetch<{ members: Member[] }>('/v1/members');
  return r.members ?? [];
}

export async function createMember(
  name: string,
  role: 'adult' | 'child' = 'adult',
  voicePack = 'warm_mom',
): Promise<string> {
  const r = await apiFetch<{ member_id: string }>('/v1/members', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, role, voice_pack: voicePack }),
  });
  return r.member_id;
}

export async function updateMember(id: string, name: string): Promise<void> {
  await apiFetch(`/v1/members/${id}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name }),
  });
}

export async function deleteMember(id: string): Promise<void> {
  await apiFetch(`/v1/members/${id}`, { method: 'DELETE' });
}

export async function getSchoolSchedule(): Promise<Record<string, unknown>> {
  const r = await apiFetch<{ payload: Record<string, unknown> }>('/v1/school_schedule');
  return r.payload ?? {};
}

export async function saveSchoolSchedule(payload: Record<string, unknown>): Promise<void> {
  await apiFetch('/v1/school_schedule', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}
